export default __webpack_public_path__ + "static/media/note2.2ccda4f7.jpeg";